import { Stack } from '@chakra-ui/react'

import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'
import CustomFormDocumentUpload from './components/CustomFormDocumentUpload'

export type CustomFormDocumentUploads = CustomFormViewerQuestionProps & {
  fileArrayPositions: [number, number, number]
}

export default function CustomFormDocumentUploads(props: CustomFormDocumentUploads) {
  return (
    <Stack>
      <CustomFormDocumentUpload label="Foto da frente do documento" {...props} />
      <CustomFormDocumentUpload
        label="Foto do verso do documento"
        {...props}
        fileArrayPositions={[
          props.fileArrayPositions[0] + 3,
          props.fileArrayPositions[1] + 3,
          props.fileArrayPositions[2] + 3,
        ]}
      />
    </Stack>
  )
}
